module.exports = __webpack_public_path__ + "static/media/sonicscale-4.6bec09e1.jpg";